import { useContext } from "react";
import { ConsentContext, ConsentContextValue } from "@/contexts/ConsentContext";

export const useConsent = (): ConsentContextValue => {
  const ctx = useContext(ConsentContext);
  if (!ctx) {
    throw new Error("useConsent must be used within a ConsentProvider");
  }
  return ctx;
};
